import { Component, OnInit } from '@angular/core';
import { FactoryStandardEquipmentAndItemsService } from 'src/app/services/sales/factory-standard-equipment-and-items.service';
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FormField } from 'src/app/interfaces/form-field.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-factory-standard-equipment-and-items',
  templateUrl: './factory-standard-equipment-and-items.component.html',
  styleUrls: ['./factory-standard-equipment-and-items.component.css']
})
export class FactoryStandardEquipmentAndItemsComponent implements OnInit {
  
  faSave = faSave;

  categoryField: FormField[] = [
    {
      type: 'select',
      id: 'category',
      label: 'Category',
      options: [],
      required: true,
      value: ''
    }
  ];

  itemsFields: FormField[] = Array.from({ length: 12 }, (_, i) => ({
    type: 'text',
    id: `DelCerDesc${i + 1}`,
    label: `${i + 1}.`,
    value: ''
  }));

  categories: any[] = [];
  selectedCategory: string = '';
  deliveryItems: any = {};
  currentId: string = '';

  constructor(
    private factoryService: FactoryStandardEquipmentAndItemsService,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.getAllCategories();
  }

  getAllCategories(): void {
    this.factoryService.getAllCategory().subscribe({
      next: (response) => {
        if (response && Array.isArray(response.body)) {
          this.categories = response.body;
          this.categoryField[0].options = this.categories.map((cat: any) => ({
            value: cat.Value,
            display: cat.Value
          }));

          if (this.categories.length > 0) {
            this.selectedCategory = this.categories[0].Value;
            this.categoryField[0].value = this.selectedCategory;
            this.getDeliveryCerByCategory(this.selectedCategory);
          }
        }
      },
      error: (error) => {
        console.error('Error fetching categories:', error);
        this.notifier.notify('error', 'Error fetching categories.');
      }
    });
  }

  getDeliveryCerByCategory(category: string): void {
    if (!category) {
      this.clearItems();
      return;
    }

    this.factoryService.getDeliveryCerByCategory(category).subscribe({
      next: (response) => {
        if (response && response.body) {
          this.deliveryItems = response.body;
          this.currentId = response.body.Id || '';
          this.populateItemsFields();
        } else {
          this.clearItems();
        }
      },
      error: (error) => {
        console.error('Error fetching delivery items:', error);
        this.notifier.notify('error', 'Error fetching delivery items.');
        this.clearItems();
      }
    });
  }

  populateItemsFields(): void {
    this.itemsFields.forEach((field, index) => {
      field.value = this.deliveryItems[`DelCerDesc${index + 1}`] || '';
    });
  }

  onCategoryChange(event: any): void {
    this.selectedCategory = event;
    this.getDeliveryCerByCategory(this.selectedCategory);
  }

  updateDeliveryCer(): void {
    if (!this.selectedCategory) {
      this.notifier.notify('error', 'Please select a category.');
      return;
    }

    const payload: any = {
      Category: this.selectedCategory,
      Id: this.currentId
    };

    this.itemsFields.forEach((field, index) => {
      payload[`DelCerDesc${index + 1}`] = field.value || '';
    });

    this.factoryService.updateDeliveryCerByCategory(payload).subscribe({
      next: (response) => {
        if (response?.body) {
          this.deliveryItems = response.body;
          this.currentId = response.body.Id || '';
          this.populateItemsFields();
        }
        this.notifier.notify('success', 'Updated Successfully!');
      },
      error: (error) => {
        console.error('Error updating Delivery Certificate:', error);
        this.notifier.notify('error', 'Error updating Factory Standard Equipment & Items.');
      }
    });
  }

  private clearItems(): void {
    this.deliveryItems = {};
    this.currentId = '';
    this.itemsFields.forEach(field => field.value = '');
  }
}
